import React from "react";
import WizardNav from "./WizardNav";

const StepPanel = ({
	stepNumber,
	totalSteps = 3,
	title,
	description,
	children,
	nav,
	status = null,
}) => {
	return (
		<section
			className="animate-fade-in-up space-y-6"
			aria-labelledby={`upload-books-step-${stepNumber}-title`}
		>
			<header className="space-y-2">
				<p className="text-xs font-semibold uppercase tracking-wider text-akgreen">
					Step {stepNumber} of {totalSteps}
				</p>
				<h2
					id={`upload-books-step-${stepNumber}-title`}
					className="text-xl font-semibold tracking-tight text-akgreenest sm:text-2xl"
				>
					{title}
				</h2>
				{description ? (
					<p className="max-w-2xl text-sm leading-relaxed text-gray-600">
						{description}
					</p>
				) : null}
			</header>
			{status}
			<div>{children}</div>
			{nav ? <WizardNav {...nav} /> : null}
		</section>
	);
};

export default StepPanel;
